import React, { memo } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import CardIcon from '@pedidosya/web-fenix/icons/CardIcon';
import Content from './Content';
import Text from './Text';
import messages from './messages';

const OnlinePaymentOnly = ({ intl: { formatMessage } }) => (
  <Content>
    <CardIcon size="small" />
    <Text>{formatMessage(messages.onlyPaymentOnline)}</Text>
  </Content>
);

OnlinePaymentOnly.propTypes = {
  intl: intlShape.isRequired,
};

export default memo(injectIntl(OnlinePaymentOnly));
